import React, { useCallback } from 'react';
import { FluentInput } from '../../../../../components/FluentUI/Fluent-Input';
import { makeStyles, shorthands } from '@fluentui/react-components';
import PropTypes from 'prop-types';

const useStyles = makeStyles({
    root: {
        display: "flex",
        padding: "5px",
        ...shorthands.border("1px", "solid", "#EEEEEE"),
        resize: "vertical !important",
        fontSize: "12px !important",
        color: "#4E4E4E",
        height: "36px",
        marginTop: "6px",
    },
});

const ProjectNameField = React.memo(({
    value,
    handleChange,
    errors,
    labels
}) => {
  const fieldStyle = useStyles();

  const onChange = useCallback((e) => {
    handleChange('Name', e.target.value);  
}, [handleChange]);

  return (
    <FluentInput
      componentStyle={fieldStyle.root}
      label={`${labels?.ProjectSingular ?? "Project"} Name`}
      defaultValue={value}
      size={"small"}
      placeholder={`Enter ${labels?.ProjectSingular ?? "Project"} Name`}
      required={true}
      onChange={onChange}
      validationMessage={errors}
      noKey={true}
    />
  )
})

ProjectNameField.propTypes = {
  errors: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  labels: PropTypes.shape({
      ProjectSingular: PropTypes.string,
      ProjectPlural: PropTypes.string,
      ProjectSingularPossessive: PropTypes.string,
      ProjectPluralPossessive: PropTypes.string,
      TaskSingular: PropTypes.string,
      TaskPlural: PropTypes.string,
      TaskSingularPossessive: PropTypes.string,
      TaskPluralPossessive: PropTypes.string,
      FormSingular: PropTypes.string,
      FormPlural: PropTypes.string,
      FormSingularPossessive: PropTypes.string,
      FormPluralPossessive: PropTypes.string,
  }),
}

export default ProjectNameField;